export default __webpack_public_path__ + "static/media/wdtxy.79bbbe62.png";